import { observer } from 'mobx-react';
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import classes from './confirmationModal.module.scss';

const ConfirmationModal = ({
  visibility,
  modalHeading,
  modalContent,
  confirmLabel = 'Confirm',
  cancelLabel = 'Cancel',
  loading,
  handleConfirm,
  handleCancel,
  confirmButtonStyle,
}: {
  visibility: boolean;
  modalHeading: string;
  modalContent: string;
  confirmLabel?: string;
  cancelLabel?: string;
  loading?: boolean;
  handleConfirm: () => void;
  handleCancel: () => void;
  confirmButtonStyle?: 'purple' | 'default';
}) => {
  const confirmButtonClass =
    confirmButtonStyle === 'purple' ? classes.confirmButtonPurple : classes.confirmbutton;
  const confirmButtonStyleObj =
    confirmButtonStyle === 'purple'
      ? { backgroundColor: '#4d2e6d', borderColor: '#4d2e6d' }
      : {};

  return (
    <Dialog
      blockScroll
      resizable={false}
      draggable={false}
      headerClassName={classes.modalHeader}
      header={modalHeading}
      visible={visibility}
      style={{ width: '30vw' }}
      onHide={() => {
        if (!visibility) return;
        handleCancel();
      }}
    >
      <div className={classes.modalContainer}>
        <div className={classes.inputTextDivWrapper}>{modalContent}</div>
        <div className={classes.buttonWrapper}>
          <Button
            className={classes.cancelButton}
            onClick={handleCancel}
            style={{ order: 1 }}
          >
            {cancelLabel}
          </Button>
          <Button
            className={confirmButtonClass}
            onClick={handleConfirm}
            loading={loading}
            style={{ order: 2, ...confirmButtonStyleObj }}
          >
            {confirmLabel}
          </Button>
        </div>
      </div>
    </Dialog>
  );
};

export default observer(ConfirmationModal);
